import { render, staticRenderFns } from "./Salir.vue?vue&type=template&id=948c28e4&"
import script from "./Salir.vue?vue&type=script&lang=js&"
export * from "./Salir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports